import useCurrentUser from '@/hooks/useCurrentUser';
import TradingAccountService from '@/lib/TradingAccount';
import { useQuery } from '@tanstack/react-query';

export default function useTradingAccount(enabled = true) {
    const { data: user } = useCurrentUser();

    const query = useQuery({
        queryKey: ['tradingAccount'],
        queryFn: async () => TradingAccountService.getTradingAccount(),
        staleTime: 1 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: 2,
        enabled: enabled && !!user?.canShowTradingFeatures
    });

    return query;
}